import { SearchItem } from '../../API/resources/tableSearch';
import {
  observable,
  action,
  computed,
  runInAction,
  makeObservable,
} from 'mobx';
import { services } from '@project/API';
import { Table } from '@datum-group/isogd-openapi/lib';
import { getDisplayGeoJSONFeature } from '../shared/LayersTree/Tree/utils';

export enum TableLoadingStatus {
  NOT_LOADED = 'notLoaded',
  LOADING = 'loading',
  LOADED = 'loaded',
}

export class ResultNode {
  @observable private _feature: SearchItem;
  @observable private _table: Table | undefined = undefined;
  @observable private _error: string | undefined = undefined;
  @observable private _loadingStatus: TableLoadingStatus =
    TableLoadingStatus.NOT_LOADED;

  constructor(feature: SearchItem) {
    this._feature = feature;
    makeObservable(this);
  }

  @computed get error() {
    return this._error;
  }

  @computed get loadingStatus() {
    return this._loadingStatus;
  }

  @computed get display() {
    if (!this._table?.display) {
      return this._feature.id;
    }

    return getDisplayGeoJSONFeature(this._feature, this._table?.display);
  }

  @computed get feature() {
    return this._feature;
  }

  @action async load() {
    runInAction(() => {
      this._table = undefined;
      this._error = undefined;
      this._loadingStatus = TableLoadingStatus.LOADING;
    });
    try {
      const response = await services.table.apiTablesRead(
        this._feature.table_name,
      );
      runInAction(() => {
        this._table = response.data;
        this._loadingStatus = TableLoadingStatus.LOADED;
      });
    } catch (e) {
      runInAction(() => {
        this._error = 'Не удалось загрузить данные таблицы';
        this._loadingStatus = TableLoadingStatus.NOT_LOADED;
      });
    }
  }
}
